(function () {
  var CONFIG = {
    watchedVariantId: 50787207446826,
    surchargeVariantId: 53056309657898,
    minQuantity: 100
    };

  var nativeFetch = window.fetch.bind(window);
  var busy = false;

  function post(url, payload) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function sync() {
    if (busy) return;
    busy = true;

    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var watchedQuantity = 0;
        var surcharge = null;

        cart.items.forEach(function (item) {
          if (item.variant_id === CONFIG.surchargeVariantId) {
            surcharge = item;
          } else if (item.variant_id === CONFIG.watchedVariantId) {
            watchedQuantity += item.quantity;
          }
        });

        var needed = watchedQuantity > 0 && watchedQuantity < CONFIG.minQuantity;

        if (needed && !surcharge) {
          return post('/cart/add.js', { items: [{ id: CONFIG.surchargeVariantId, quantity: 1 }] }).then(function () { return true; });
        }
        if (needed && surcharge.quantity !== 1) {
          return post('/cart/change.js', { id: surcharge.key, quantity: 1 }).then(function () { return true; });
        }
        if (!needed && surcharge) {
          return post('/cart/change.js', { id: surcharge.key, quantity: 0 }).then(function () { return true; });
        }
        return false;
      })
      .then(function (changed) {
        busy = false;
        if (changed && window.location.pathname.indexOf('/cart') === 0) {
          window.location.reload();
        }
      })
      .catch(function () {
        busy = false;
      });
  }

  function isCartUrl(url) {
    return /\/cart\/(add|change|update|clear)/.test(String(url || ''));
  }

  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = nativeFetch.apply(window, arguments);
    if (isCartUrl(url)) {
      result.then(function () { setTimeout(sync, 0); }).catch(function () {});
    }
    return result;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartUrl(url)) {
      this.addEventListener('loadend', function () { setTimeout(sync, 0); });
    }
    return nativeOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
    } else {
    sync();
    }
})();